<template>
<div class="template oftenHref">
  <el-form :inline="true">
    <el-form-item>
      <el-input v-model="keyTxt" :placeholder="$t('im.oftenFile.inputTitleKey')"></el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="searchResource">{{$t('im.bt.search')}}</el-button>
      <el-button type="primary" @click="addPop">{{$t('im.oftenFile.addOftenHref')}}</el-button>
      <el-button @click="deleteAllPop">{{$t('im.bt.delete')}}</el-button>
    </el-form-item>
  </el-form>
  <el-tabs type="border-card" v-model="businessGroupCodeTab" @tab-click="changeTab">
    <el-tab-pane v-for="item in businessGroupData" :name="item.code">
      <span slot="label">{{item.name}}</span>
      <el-table border v-if="tableList" :data="tableList" tooltip-effect="dark" style="width: 100%" @selection-change="selectionResource">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column :prop="itemTabNav.id" :label="itemTabNav.name" v-for="itemTabNav in tableNav" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column :label="$t('im.bt.operator')">
          <template slot-scope="scope">
            <el-button size="mini" @click="editResourcePop(scope.row)">{{$t('im.bt.update')}}</el-button>
            <el-button size="mini" type="danger" @click="deletePop(scope.row)">{{$t('im.bt.delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="flexEnd" v-if="totalNum>0">
        <el-pagination
          background
          @size-change="pageSizeChange"
          @current-change="currentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40, 50]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum">
        </el-pagination>
      </div>
    </el-tab-pane>
  </el-tabs>
  <el-dialog :title="oftenTitle" :visible.sync="isToOftenPop">
    <el-form class="div_form" label-width="80px">
      <el-form-item :label="$t('im.common.bizCodeName')">
        <el-select v-model="businessGroupCode" :placeholder="$t('im.common.placeholderBizCodeName')">
          <el-option
            v-for="item in businessGroupData"
            :key="item.code"
            :label="item.name"
            :value="item.code">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('im.common.locale')">
        <el-select v-model="langId" :placeholder="$t('im.common.placeholderLanguage')">
          <el-option
            v-for="item in langList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('im.common.title')">
        <el-input v-model="titleTxt" maxlength="100" show-word-limit></el-input>
      </el-form-item>
      <el-form-item :label="$t('im.oftenFile.hrefUrl')">
        <el-input type="textarea" :rows="2" maxlength="100" show-word-limit v-model="contentTxt"></el-input>
      </el-form-item>
    </el-form>
    <div class="flexCenter">
      <el-button type="primary" @click="submitSave">{{$t('im.bt.definite')}}</el-button>
      <el-button @click="isToOftenPop=false">{{$t('im.bt.cancel')}}</el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
  require('@/styles/IM/template.css')
  import apiDeployManagement from '@/api/im/deployManagement'
  import Util from '@/utils/IM/tradeDataUtil'
  import { localRead } from '@/utils/tools'
  export default {
    name: 'oftenHref',
    data() {
      return {
        util: Util,
        userInfo: JSON.parse(localRead('sys_userInfo_IM')),  //用户信息
        keyTxt: '',  //关键字查询
        businessGroupData: JSON.parse(localRead('sys_userInfo_IM')).businessIdUser,  //业务编码列表
        businessGroupCodeTab: '',  //tab业务编码Code
        businessGroupCode: '',  //弹窗业务编码Code
        langList: JSON.parse(localRead('locale_IM')),  //语言列表
        langId: 'zh_CN',  //默认弹窗显示语言的ID
        tableList: [],  //当前资源列表
        tableNav: [
          { name: window.$t('im.common.title'), id: 'name' },
          { name: window.$t('im.common.locale'), id: 'localeName' },
          { name: window.$t('im.common.hreAddress'), id: 'address' }
        ],  //当前资源列表头部
        totalNum: 0,  //当前资源条数
        currentPage:1,  //当前页数
        pageSize:10, //当前页条数数
        resourceID: '',//当前数据ID
        resourceType: '',//0：新增，1：编辑
        oftenTitle: window.$t('im.oftenFile.addOftenHref'),//弹窗名称
        isToOftenPop: false,  //弹窗是否显示
        titleTxt: '',  //标题
        contentTxt: '',  //链接地址
        multipleSelection:[],  //选择条数集合
      }
    },
    methods:{
      /*初始化业务组tab*/
      initBusinessGroup() {
        if (this.businessGroupData.length > 0) {
          this.businessGroupCodeTab = this.businessGroupData[0].code
          this.businessGroupCode = this.businessGroupData[0].code
        }
      },
      /*业务组tab*/
      changeTab(tab) {
        this.businessGroupCodeTab = tab.name
        this.businessGroupCode = tab.name
        this.initResource()
      },
      /*选择资源*/
      selectionResource(val) {
        let data = []
        if (val.length > 0) {
          for (const i in val) {
            data.push(val[i].id)
          }
          this.multipleSelection = data
        } else {
          this.multipleSelection = []
        }
      },
      /*修改当前*/
      editResourcePop(data) {
        this.isToOftenPop = true
        this.resourceType = 1
        this.oftenTitle = window.$t('im.oftenFile.updateOftenHref')
        this.titleTxt = data.name
        this.contentTxt = data.address
        this.resourceID = data.id
        this.langId = data.locale
        this.businessGroupCode = data.bizCode
      },
      /*删除弹窗*/
      deletePop(row) {
        this.$confirm(window.$t('im.common.delForever'), window.$t('im.common.tip'), {
          confirmButtonText: window.$t('im.bt.definite'),
          cancelButtonText: window.$t('im.bt.cancel'),
          type: 'warning',
          center: true
        }).then(() => {
          this.deleteResource(row)
        }).catch(() => {
          this.$message.info(window.$t('im.common.cancelDel'))
        })
      },
      /*删除当前*/
      deleteResource(row) {
        let data = { id: row.id }
        apiDeployManagement.deleteConCommonResource(data).then(res => {
          if (res.code == 0 && res.result == true) {
            this.$message.success(window.$t('im.common.delSuc'))
            let data = {
              companyId: this.userInfo.companyId,
              bizCode: this.businessGroupCodeTab,
              resourceType: 0,
              pageNum: this.currentPage,
              name: this.keyTxt
            }
            this.getResource(data)
          } else {
            this.$message.error(window.$t('im.common.delFail'));
          }
        })
      },
      /*删除所有弹窗*/
      deleteAllPop() {
        if (this.multipleSelection.length > 0){
          this.$confirm(window.$t('im.common.delForever'), window.$t('im.common.tip'), {
            confirmButtonText: window.$t('im.bt.definite'),
            cancelButtonText: window.$t('im.bt.cancel'),
            type: 'warning',
            center: true
          }).then(() => {
            this.deleteAllResource()
          }).catch(() => {
            this.$message.info(window.$t('im.common.cancelDel'))
          })
        }
      },
      /*删除所有*/
      deleteAllResource() {
        let data = { ids: this.multipleSelection.join(',') }
        apiDeployManagement.deleteBatchConCommonResource(data).then(res => {
          if (res.code == 0 && res.result == true) {
            this.$message.success(window.$t('im.common.delSuc'))
            let data = {
              companyId: this.userInfo.companyId,
              bizCode: this.businessGroupCodeTab,
              resourceType: 0,
              pageNum: this.currentPage,
              name: this.keyTxt
            }
            this.getResource(data)
          } else {
            this.$message.error(window.$t('im.common.delFail'));
          }
        })
      },
      /*新建常用链接弹窗*/
      addPop() {
        this.isToOftenPop = true
        this.resourceType = 0
        this.oftenTitle = window.$t('im.oftenFile.addOftenHref')
        this.titleTxt = ''
        this.contentTxt = ''
      },
      /*获取数据*/
      getResource(data){
        apiDeployManagement.queryConCommonResourceListPage(data).then(res => {
          if (res.code == 0) {
            if (res.result.list) {
              let newData = JSON.parse(JSON.stringify(res.result.list))
              for (const i in newData) {
                for (const j in this.langList) {
                  if (this.langList[j].id == newData[i].locale) {
                    newData[i].localeName = this.langList[j].name
                  }
                }
              }
              this.tableList = newData
              this.totalNum = res.result.total
            } else {
              this.tableList = []
              this.totalNum = 0
            }
          }
        })
      },
      /*初始化数据*/
      initResource() {
        let data = {
          companyId: this.userInfo.companyId,
          bizCode: this.businessGroupCodeTab,
          resourceType: 0,
          pageNum: this.currentPage,
          pageSize: this.pageSize,
        }
        this.getResource(data)
      },
      /*切换分页条数*/
      pageSizeChange(val) {
        this.pageSize = val
        let data = {
          companyId: this.userInfo.companyId,
          bizCode: this.businessGroupCodeTab,
          resourceType: 0,
          pageNum: this.currentPage,
          pageSize: val,
          name: this.keyTxt
        }
        this.getResource(data)
      },
      /*切换当前页*/
      currentChange(val) {
        this.currentPage = val
        let data = {
          companyId: this.userInfo.companyId,
          bizCode: this.businessGroupCodeTab,
          pageNum: val,
          pageSize: this.pageSize,
          resourceType: 0,
          name: this.keyTxt
        }
        this.getResource(data)
      },
      /*关键字查询*/
      searchResource() {
        let data = {
          companyId: this.userInfo.companyId,
          bizCode: this.businessGroupCodeTab,
          resourceType: 0,
          pageNum: 1,
          name: this.keyTxt
        }
        this.getResource(data)
      },
      /*新增数据*/
      addResource(){
        let data = {
          operator: this.userInfo.id,
          operatorName: this.userInfo.displayName,
          companyId: this.userInfo.companyId,
          resourceType: 0,
          bizCode: this.businessGroupCode,
          locale: this.langId,
          name: this.titleTxt,
          address: this.contentTxt
        }
        apiDeployManagement.addConCommonResource(data).then(res => {
          if (res.code == 0) {
            this.isToOftenPop = false
            this.initResource()
          }
        })
      },
      /*修改数据*/
      editResource() {
        let data = {
          operator: this.userInfo.id,
          operatorName: this.userInfo.displayName,
          companyId: this.userInfo.companyId,
          resourceType: 0,
          bizCode: this.businessGroupCode,
          locale: this.langId,
          name: this.titleTxt,
          address: this.contentTxt,
          id: this.resourceID
        }
        apiDeployManagement.updateConCommonResource(data).then(res => {
          if (res.code == 0) {
            this.isToOftenPop = false
            this.initResource()
          }
        })
      },
      /*保存数据*/
      submitSave() {
        if (Util.isNotEmpty(this.titleTxt.replace(/\s/g, '')) && Util.isNotEmpty(this.contentTxt.replace(/\s/g, ''))) {
          if (this.resourceType == 0) {
            this.addResource()
          } else if (this.resourceType == 1) this.editResource()
        } else {
          this.$message.error(window.$t('im.oftenFile.titleOrHref'))
        }
      }
    },
    mounted() {
      this.initBusinessGroup()
      this.initResource()
    }
  }
</script>

<style>
  .oftenHref .div_form .el-select{width: 100%}
  .oftenHref .flexEnd .el-input__count{line-height: normal}
</style>
